function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "sun-f",
  d: "M9.5,14.815a4.75,4.75,0,1,1,4.75-4.75A4.75,4.75,0,0,1,9.5,14.815ZM9.5.565a.95.95,0,0,1,.95.95v1.9a.95.95,0,1,1-1.9,0v-1.9A.95.95,0,0,1,9.5.565Zm0,15.2a.95.95,0,0,1,.95.95v1.9a.95.95,0,1,1-1.9,0v-1.9A.95.95,0,0,1,9.5,15.765ZM.95,9.115h1.9a.95.95,0,0,1,0,1.9H.95a.95.95,0,0,1,0-1.9Zm15.2,0h1.9a.95.95,0,0,1,0,1.9h-1.9a.95.95,0,1,1,0-1.9Zm.067-5.767a.95.95,0,0,1,0,1.343L14.874,6.034a.95.95,0,1,1-1.343-1.343l1.343-1.343a.95.95,0,0,1,1.343,0ZM5.469,14.1a.95.95,0,0,1,0,1.343L4.126,16.782a.95.95,0,1,1-1.343-1.343L4.126,14.1a.95.95,0,0,1,1.343,0ZM4.126,3.348,5.469,4.691A.95.95,0,1,1,4.126,6.034L2.783,4.691A.95.95,0,1,1,4.127,3.347ZM14.874,14.1l1.343,1.343a.95.95,0,1,1-1.343,1.343l-1.343-1.343A.95.95,0,1,1,14.874,14.1Z",
  transform: "translate(0 -0.565)",
  fill: "#323232"
});

function SvgIconHabitSun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHabitSun);
export default ForwardRef;